module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-14.89beb04b.png";